<i18n>
{
    "en_US": {
        "logout": "Sign-out",
        "language": "Change language",
        "configuration": "Configure your account"
    },
    "fr_FR": {
        "logout": "Se déconnecter",
        "language": "Changer de langue",
        "configuration": "Configurer votre compte"
    }
}
</i18n>

<template>
    <div class="user-menu">
        <div class="btn-group" role="group">
            <button type="button" class="btn btn-secondary btn-flex" v-on:click.prevent="disconnect" v-bind:title="$t('logout')">
                <i class="fa fa-sign-out-alt"></i>
            </button>
            <button class="btn btn-secondary dropdown-toggle btn-flex" type="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" v-bind:title="$t('language')">
                <i class="flag-icon flag-icon-us" v-if="language == 'en_US'"></i>
                <i class="flag-icon flag-icon-fr" v-else-if="language == 'fr_FR'"></i>
            </button>
            <div class="dropdown-menu dropdown-menu-left">
                <button class="dropdown-item" type="button" v-on:click="toggle" data-lang="en_US"><span class="flag-icon flag-icon-us"></span> English</button>
                <button class="dropdown-item" type="button" v-on:click="toggle" data-lang="fr_FR"><span class="flag-icon flag-icon-fr"></span> Français</button>
            </div>
            <button type="button" class="btn btn-secondary btn-flex" v-on:click.prevent="modal" v-bind:title="$t('configuration')">
                <i class="fa fa-cogs"></i>
            </button>
        </div>
    </div>
</template>

<script>
    import { mapState, mapMutations, mapActions } from "vuex";
    export default {
        name: "UserBar",
        computed: {
            ...mapState("language", ["language"])
        },
        mounted: function() {
            // Fixing a bug between bootstrap and material design...
            $(".dropdown-toggle").dropdown();
        },
        methods: {
            disconnect: function() {
                this.logout()
                    .then(function() {
                        this.$Progress.finish();
                        this.$router.push({
                            name: "login"
                        });
                    }.bind(this))
                    .catch(function() {});
            },
            toggle: function(event) {
                let el = $(event.target);
                if (!el.hasClass("dropdown-item")) {
                    el = el.closest(".dropdown-item");
                }
                const lang = el.attr("data-lang");
                // We store the language
                this.setLanguage(lang);
                // ... and send it to server for permanent storage
                this.saveLanguage({
                    language: lang
                })
                    .then(function() {
                        this.$Progress.finish();
                    }.bind(this))
                    .catch(function() {});
            },
            modal: function() {
                this.showModalUser();
                this.hideMenuMobile();
            },
            ...mapActions("user", ["logout"]),
            ...mapActions("language", {
                saveLanguage: "language"
            }),
            ...mapMutations("application", ["hideMenuMobile"]),
            ...mapMutations("language", ["setLanguage"]),
            ...mapMutations("application", ["showModalUser"])
        }
    }
</script>

<style scoped>
    .user-menu {
        display: flex;
        height: 55px;
        border-top: 1px solid #e4eaec;
    }
    .btn-group, .btn-flex {
        flex: 1 !important;
    }
    .btn-group, .btn-secondary {
        margin-top: 0;
        margin-bottom: 0;
    }
    .dropdown-toggle, .dropdown-toggle:hover {
        -webkit-box-shadow: none !important;
        -moz-box-shadow: none !important;
        -o-box-shadow: none !important;
        box-shadow: none !important;
    }
    .dropdown-menu .dropdown-item {
        cursor: pointer;
    }
    .dropdown-toggle > i {
        margin-right: 3px;
    }
    .dropdown button {
        cursor: pointer;
    }
    span {
        margin-top: -5px;
        margin-right: 10px;
    }
</style>
